import type { DateTime } from "luxon";
import type { PerspectiveViewConfig } from "@/models/perspective";

export interface TracesInMemoryFilters {
  dataExplorerFilters: {
    groupByColumn: string | null;
    selectedGroup: string;
    selectedAttribute: string;
  };
  tableFilters: {
    elapsedRange: [number, number];
    errorState: string;
    regex: string;
    serviceName: string | null;
  };
}

// Type definition for the traces module vuex state object.
export interface TracesState {
  latestQueryStartedAt: DateTime | undefined;
  loading: boolean | undefined;
  shouldExecuteQuery: boolean | undefined;
  updateTraces: number;
  fetchLimit: number | undefined;
  streamingIsPaused: boolean | undefined;
  shouldShowTable: boolean;
  dynamicColumns: Array<string>;
  dataProcessed: number;
  dataReturned: number;
  // TODO: Delete once DuckDB is set as the main source for data
  updateWarehouse: number;
  tracesCount: number;
  hasReportedTraces: boolean;
  tableConfiguration: PerspectiveViewConfig;
  tableSchema: Record<string, string>;
  shouldClearTable: boolean;
  applyConfiguration: boolean;
  // TODO: Delete once DuckDB is set as the main source for data
  splitByAttribute: string | undefined;
  inMemoryFilters: TracesInMemoryFilters;
}

/**
 * Create a state object for the traces module.
 * @returns A state object initialized for use in the traces module.
 */
export function makeState(): TracesState {
  return {
    latestQueryStartedAt: undefined,
    loading: undefined,
    shouldExecuteQuery: undefined,
    updateTraces: 0,
    fetchLimit: undefined,
    streamingIsPaused: undefined,
    shouldShowTable: false,
    dynamicColumns: [],
    dataProcessed: 0,
    dataReturned: 0,
    updateWarehouse: 0,
    tracesCount: 0,
    hasReportedTraces: true,
    tableConfiguration: {
      aggregates: {},
      group_by: [],
      columns: [],
      expressions: [],
      filter: [],
      plugin: "Datagrid",
      plugin_config: {
        scroll_lock: false,
        editable: false,
        columns: {},
      },
      split_by: [],
      settings: true,
      sort: [],
    },
    tableSchema: {
      elapsed: "integer",
      ends: "datetime",
      id: "string",
      label: "string",
      language: "string",
      libraryName: "string",
      libraryVersion: "string",
      name: "string",
      serviceInstanceId: "string",
      serviceName: "string",
      serviceNamespace: "string",
      serviceVersion: "string",
      starts: "datetime",
      statusCode: "integer",
      statusMessage: "string",
    },
    shouldClearTable: false,
    applyConfiguration: false,
    splitByAttribute: undefined,
    inMemoryFilters: {
      dataExplorerFilters: {
        groupByColumn: null,
        selectedGroup: "",
        selectedAttribute: "",
      },
      tableFilters: {
        elapsedRange: [0, 9_999_999],
        errorState: "all",
        regex: "",
        serviceName: null,
      },
    },
  };
}
